<script>
   /**************************************************************/
   /* Svelte component for VariancePlot settings                 */
   /**************************************************************/

   import { Container, Select } from '../controls';

   export let params;
   export let model;
   export let res;

   let vartype = 'expvar';
   $: params = {
      vartype: vartype
   }

</script>

<Container label="">
<p class="title">Variance</p>
</Container>

{#if model && res}
<Container label="Type">
<Select id="variance" bind:value={vartype} options={["expvar", "cumexpvar"]} />
</Container>
{/if}
